import { render, staticRenderFns } from "./SquadList.vue?vue&type=template&id=8960c6a4&scoped=true"
import script from "./SquadList.vue?vue&type=script&lang=js"
export * from "./SquadList.vue?vue&type=script&lang=js"
import style0 from "./SquadList.vue?vue&type=style&index=0&id=8960c6a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8960c6a4",
  null
  
)

export default component.exports